import { useContext } from 'react';
import styled from 'styled-components';

import { Button } from '~ui-kit';
import { DialogContext } from './Dialog';
import { lighterGrey, green } from '~theme';

const ModalButtons = ({
  closeButtonText,
  onCloseButtonClick,
  confirmButtonText,
  onConfirmButtonClick,
  confirmDisabled,
}) => {
  const { close } = useContext(DialogContext);
  const backOnClick = onCloseButtonClick ?? close;

  return (
    <Buttons>
      <Button w="48%" h="40px" bgColor={lighterGrey} onClick={backOnClick}>
        {closeButtonText || 'Peruuta'}
      </Button>
      <Button
        w="48%"
        h="40px"
        bgColor={confirmDisabled ? lighterGrey : green}
        onClick={onConfirmButtonClick}
        disabled={confirmDisabled}
      >
        {confirmButtonText || 'Ok'}
      </Button>
    </Buttons>
  );
};

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default ModalButtons;
